export default __webpack_public_path__ + "static/media/foot2.1790137b.jpg";